<div
  class="plot"
  echarts
  [autoResize]="true"
  [options]="chartOption">
</div>
